function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Spin } from "antd";
import React, { useContext, useEffect } from "react";
import { useStore } from "../../hooks/useStore";
import { GetItContext } from "../../base/provider/GetItContext";
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { LocalStateValue } from "imagica-corekit/dist/base/api/viewBuilderTyped/ViewBuilderStore";
import { ViewbuilderStore } from "imagica-corekit/dist/cases/store/ViewbuilderStore";
import { VBComponentsMapping } from "./viewbuilderConfig/VBComponentsMapping";
import { ViewBuilderUtil } from "./ViewBuilderUtil";
import { ViewBuilderImgService } from "imagica-corekit/dist/cases/service/ViewBuilderImgService";
export function GraphComponent(props) {
  var getIt = useContext(GetItContext);
  var viewBuilderImgService = getIt(ViewBuilderImgService);
  var viewbuilderStore = getIt(ViewbuilderStore);
  var viewbuilderStoreState = useStore(viewbuilderStore);
  var viewBuilderLocalState = viewbuilderStoreState.value["viewBuilderLocalState"];
  var localState = viewBuilderLocalState[props.blueprint_id] || new LocalStateValue(props.data || undefined);
  var componentId = props.component_id;
  var componentData = ViewBuilderUtil.useMockData(localState.data, componentId, localState.noUseMockData);
  var component = VBComponentsMapping[componentId];
  useEffect(function () {
    var imgs = [];
    if (Array.isArray(componentData)) {
      componentData.forEach(function (c) {
        imgs.concat(viewBuilderImgService.getAllComponentTypeImgs(componentId, c));
      });
    } else {
      imgs = viewBuilderImgService.getAllComponentTypeImgs(componentId, componentData);
    }
    imgs.forEach(function (img) {
      viewBuilderImgService.getCorrespondingImage({
        imgUrl: img.imgKey,
        autoFillLen: img.autoFillLen
      });
    });
  }, [viewbuilderStoreState.value["viewBuilderLocalState"]]);
  if (isBlank(component)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (Array.isArray(props.data)) {
    var data = props.data,
      rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement("div", null, data.map(function (child, index) {
      return /*#__PURE__*/React.createElement(GraphComponent, _extends({}, rest, {
        key: props.interface_id + index,
        component_index_id: props.interface_id + index,
        component_id: props.component_id,
        layout: props.layout,
        interface_id: props.interface_id,
        data: child
      }));
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "10px",
      padding: "0 20px"
    }
  }, /*#__PURE__*/React.createElement(Spin, {
    spinning: localState.loading
  }, /*#__PURE__*/React.createElement(component, _objectSpread({
    key: props.component_index_id,
    type: props.component_id
  }, componentData))));
}